import paths from "routes/paths";
import CommonUtils from "services/common/utils";
import XHTTP from "services/api/xhttp";

export class AlertEventsApi {
  static END_POINTS = {
    alertEvents: paths.api.alertFactory.alertEvents,
    alertEventsViewer: paths.api.alertFactory.alertEventsViewer,
  };

  static getAlertEvents(pagination, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(pagination);

    return XHTTP(`${this.END_POINTS.alertEvents}?${queryString}`, {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static updateAlertEventsViewer(body) {
    return XHTTP(`${this.END_POINTS.alertEventsViewer}`, {
      method: "put",
      body: JSON.stringify(body),
    });
  }
}
